import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/auth.store';

export default function TimePunchesPage() {
  const navigate = useNavigate();
  const user = useAuthStore((state) => state.user);

  console.log('TimePunchesPage - user:', user);
  console.log('TimePunchesPage - user.role:', user?.role);

  useEffect(() => {
    if (!user) {
      console.log('No user found, waiting...');
      return;
    }

    console.log('Checking role:', user.role);
    // Redirect based on user role - check for lowercase and uppercase
    const role = user.role?.toUpperCase();
    if (role === 'ADMIN' || role === 'MANAGER' || role === 'SUPERVISOR') {
      console.log('Redirecting to admin view');
      navigate('/time-punches/admin', { replace: true });
    } else {
      console.log('Redirecting to agent view');
      navigate('/time-punches/agent', { replace: true });
    }
  }, [user, navigate]);

  // Show loading while redirecting
  return (
    <div className="flex items-center justify-center h-64">
      <p className="text-gray-500">Loading...</p>
    </div>
  );
}
